import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  gap: 20px;
  padding: 0 10px 0 0;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 20px;
  color: #303030;
`

export const Button = styled.button<{ variant?: 'primary' | 'outline' | 'danger' | 'danger-outline' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;

  ${({ variant }) => {
    switch (variant) {
      case 'primary':
        return `
          background-color: #0090D3;
          color: #FFFFFF;
          border-color: #0090D3;
        `;
      case 'danger':
        return `
          background-color: #F87171;
          color: #FFFFFF;
          border-color: #F87171;
        `;
      case 'danger-outline':
        return `
          background-color: #FFFFFF;
          color: #F87171;
        border-color: #F87171;
        `;
      case 'outline':
      default:
        return `
          background-color: #FFFFFF;
          color: #0090D3;
          border-color: #0090D3;
        `;
    }
  }}
`;

export const Card = styled.div`
  background-color: #FFFFFF;
  border-radius: 16px;
  border-left: 1px solid #f4f4f4;
  padding: 20px;
  margin-bottom: 20px;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

export const SubTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #303030;
`

export const FormGrid = styled.div<{ columns?: number }>`
  display: ${props => props.columns ? 'grid' : 'flex'};
  ${props => props.columns ? `grid-template-columns: repeat(${props.columns}, 1fr);` : ''}
  gap: 32px;
  margin-bottom: 20px;
`

export const FormGroup = styled.div<{ hasIcon?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  min-width: 0;

  ${props => props.hasIcon && `
    & > svg {
      position: absolute;
      right: 16px;
      bottom: 12px;
      color: #696969;
      pointer-events: none;
      z-index: 1;
    }

    & > input {
      padding-right: 48px;
    }
  `}
`

export const Label = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
`

export const Select = styled.select<{ hasError?: boolean }>`
  padding: 10px 16px;
  padding-right: 40px;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  appearance: none; 
  width: 100%;
  min-width: 0;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23696969' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 16px;

  ${props => props.hasError && `
    border: 1.5px solid #F87171;
    box-shadow: 0 0 3px #F87171;
  `}
`;

export const Input = styled.input<{ hasError?: boolean }>`
  padding: 10px 16px;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  ${props => props.hasError && `
    border: 1.5px solid #F87171;
    box-shadow: 0 0 3px #F87171;
  `}

  &[readonly] {
    background-color:rgb(164, 164, 164);
  }


`;

export const FormErrorMessage = styled.p`
  color: #F87171;
  font-size: 0.8rem;
  margin: 4px 0 0 16px;
  font-family: 'Inter', sans-serif;
`;

export const InfoLink = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0090D3;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  ${props => props.disabled && `
    color: #9e9e9e;
    cursor: not-allowed;
  `}
`;

export const Separator = styled.hr<{ margin?: string }>`
  border: none;
  height: 1px;
  background-color: #EBEBEB;
  ${(props) => props.margin ? `margin: ${props.margin};` : 'margin: 20px 0;'}
`

export const CollapsibleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 16px;
`

export const CircularCollapseIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #DADADA;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  z-index: 10;

  &:hover {
    border-color: #0090D3;
    background: #f8fafb;
  }

  svg {
    width: 16px;
    height: 16px;
    color: #666;
    transition: color 0.2s ease;
  }

  &:hover svg {
    color: #0090D3;
  }
`;

export const AddNewItemButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`

export const AddProductButton = styled.button<{ variant?: 'primary' | 'outline' }>`
  width: fit-content;
  padding: .5rem 1rem;
  outline: none;
  border-radius: 2rem;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  margin: 0 auto;
  cursor: pointer;
  border: 1px solid #0090D3;

  ${({ variant }) => {
    switch (variant) {
      case 'outline':
        return `
          color: #0090D3;
          background-color: #fff;
          border-color: #0090D3;
        `;
      case 'primary':
      default:
        return `
          color: #fff;
          background-color: #0090D3;
          border-color: #0090D3;
        `;
    }
  }}
`

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalWrapper = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  text-align: center;
`;

export const ModalIcon = styled.div`
  margin-bottom: 16px;
  color: #F87171;
`;

export const ModalTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #303030;
  margin: 0 0 8px 0;
`;

export const ModalMessage = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #696969;
  margin: 0 0 24px 0;
  line-height: 1.5;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
`;

export const IconButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0090D3;
  padding: 4px;
  
  &:hover {
    background-color: #f0f9ff;
    border-radius: 50%;
  }
  
  &:disabled {
    color: #9e9e9e;
    cursor: not-allowed;
  }
`;

export const AttachmentList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 8px 0 0 0;
`;

export const AttachmentListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  background-color: #EBEBEB;
  border-radius: 20px;
  margin-bottom: 8px;
  font-family: 'Inter', sans-serif;
`;

export const RemoveAttachmentButton = styled.button`
  background: none;
  border: none;
  color: #F87171;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;

  &:hover {
    color: #DC2626;
  }
`;

export const AttachmentInputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const AttachmentTrigger = styled.div<{ hasError?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  min-height: 25px;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  ${props => props.hasError && `
    border: 1.5px solid #F87171;
    box-shadow: 0 0 3px #F87171;
  `}
`;

export const AttachmentPlaceholder = styled.span`
  color: #696969;
`;

export const TrashIconContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #F87171;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;

  &:hover {
    color: #DC2626;
  }
`;

export const StyledCurrencyInput = styled.input.attrs({ as: 'input' }) <{
  hasError?: boolean;
  value?: number | string;
  onValueChange?: (value: string) => void;
  intlConfig?: { locale: string; currency: string };
  placeholder?: string;
}>`
  padding: 10px 16px;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  width: 100%;

  ${props => props.hasError && `
    border: 1.5px solid #F87171;
    box-shadow: 0 0 3px #F87171;
  `}
`;

export const CustomCheckbox = styled.div<{ checked: boolean; hasIcon?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  border-radius: 20px;
  background-color: ${props => props.checked ? '#0090D3' : '#EBEBEB'};
  color: ${props => props.checked ? '#FFFFFF' : '#696969'};
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  
  svg {
    color: ${props => props.checked ? '#FFFFFF' : '#696969'};
  }
`;

export const Summary = styled.div`
  display: flex;
  gap: 32px;
`;

export const SummaryItem = styled.div`
  flex: 1;
  display: flex;
  gap: 8px;
`;

export const SummaryLabel = styled.span`
  font-family: 'Inter', sans-serif;
  color: #696969;
  white-space: nowrap;
`;

export const SummaryValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
  flex: 1;
`;